module.exports = __webpack_public_path__ + "static/media/Services-01.4300f028.jpg";